<template>
  <div v-if="reloadComponentDiv">
    <devAddLineInputs
      v-if="showLineInputs"
      :typeLine="lineInputsEdit"
      :objItem="objItem"
      :editableKey="false"
      @actionList="actionList"
      @close="closeLine"
    />

    <v-simple-table v-if="attrList.length > 0" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left px-2" width="45%">Atributo</th>
            <th class="text-left px-2" width="45%">Valor</th>
            <th class="text-right px-2" width="10%"></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in attrList" :key="index">
            <template v-if="typeof Object.values(item)[0] !== 'object'">
              <td class="px-2" width="45%">
                <span
                  class="font-weight-medium grey--text text--darken-3"
                >{{ Object.keys(item)[0] }}</span>
              </td>

              <td class="px-2 grey--text text--darken-3" width="45%">{{ Object.values(item)[0] }}</td>

              <td class="text-right mr-0 px-2" width="10%">
                <v-menu left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="mr-0" size="18">mdi-dots-vertical</v-icon>
                  </template>

                  <v-list class="py-0" dense hover>
                    <v-list-item class="px-0 py-0">
                      <v-list-item-title>
                        <v-btn @click="handleShowLineEditAttributes(item, index)" text width="100%">
                          <v-icon color="grey darken-3" class="mr-2" small>edit</v-icon>Editar
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>

            <td v-else colspan="3" class="px-0" width="100%">
              <v-expansion-panels hover focusable>
                <v-expansion-panel class="v-expansion-panel--expandable-table">
                  <v-expansion-panel-header>
                    <span
                      class="my-0 pl-2 text-subtitle-2 font-weight-medium grey--text text--darken-3"
                    >{{ Object.keys(item)[0] }}</span>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <devSimpleObjectAttributes :value="Object.values(item)[0]" />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  name: 'devSimpleObjectAttributes',

  components: {
    devAddLineInputs: () => import('@/components/dev/dev-add-line-inputs')
  },

  props: {
    value: { type: [Object, Array], default: () => ({} || []) },
    model: { type: Object, default: () => ({}) },
    schema: { type: Object, default: () => ({}) }
  },

  data: () => ({
    attrList: [],
    copyModels: {},
    reloadComponentDiv: true,
    showLineInputs: false,
    lineInputsEdit: false,
    objItem: { key: '', value: '' }
  }),

  mounted() {
    this.getValueList(this.value);
  },

  methods: {
    getValueList(list) {
      for (let [key_, value_] of Object.entries(list)) {
        this.attrList.push({ [key_]: value_ });
      }
    },

    closeLine() {
      this.showLineInputs = false;
    },

    reloadComponent() {
      this.reloadComponentDiv = false;

      this.$nextTick(() => (this.reloadComponentDiv = true));
    },

    actionList(result) {
      if (result.type == 'edit') {
        this.editAttrObj(result.key, result.value);

        return;
      }

      this.addAttrObj(result.key, result.value);
    },

    handleShowLineEditAttributes(itemObj, index) {
      let itemKey = Object.keys(itemObj)[0];
      let itemValue = Object.values(itemObj)[0];

      this.objItem.key = itemKey;
      this.objItem.value = itemValue;

      this.lineInputsEdit = true;
      this.showLineInputs = true;

      this.copyModels.key = itemKey;
      this.copyModels.value = itemValue;
      this.copyModels.index = index;
    },

    addAttrObj(key, value) {
      this.attrList.push({ [key]: value });
      this.value[key] = value;

      this.showLineInputs = false;
    },

    editAttrObj(key, value) {
      this.attrList[this.copyModels.index] = { [key]: value };

      if (this.copyModels.key != key) delete this.value[this.copyModels.key];

      this.value[key] = value;

      this.showLineInputs = false;

      this.reloadComponent();

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    deleteObj(item, index) {
      this.attrList.splice(index, 1);

      delete this.value[Object.keys(item)[0]];

      this.reloadComponent();
    }
  }
};
</script>
